import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerOrderListComponent } from './components/customer/customer-order-list/customer-order-list.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CustomerSingleOrderListComponent } from './components/customer/customer-single-order-list/customer-single-order-list.component';



/*Set the routes for all project */

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent
      },
     
     

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
